import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, SimpleChanges } from '@angular/core';
import { FormGroup, } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NzI18nService, en_US, zh_CN } from 'ng-zorro-antd/i18n';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subscription, filter, interval } from 'rxjs';
import { UserData } from 'src/app/models/userData.model';
import { CartService } from 'src/app/services/cart.service';
import { LoginService } from 'src/app/services/login.service';
import { NotificationService } from 'src/app/services/notification.service';
import { CustomerService } from 'src/app/services/customer.service';
import { Px2RemService } from 'src/app/services/px2-rem.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
import { LoadingService } from 'src/app/services/loading.service';
import { GlobalService } from 'src/app/services/global-service.service';

type MenuItemDesktop = MenuItemLink | MenuItemSubmenu;

interface BaseMenuItem {
  type: 'item' | 'submenu';
  title: string;
  selectedKey: boolean;
  url: string;
  pageKey: string;
  needCountry: boolean;
  params: {};
}
interface MenuItemLink extends BaseMenuItem {
  type: 'item';
}

interface MenuItemSubmenu extends BaseMenuItem {
  type: 'submenu';
  highlightClass?: string;
  groups: MenuGroup[];
}

interface MenuGroup {
  title: string;
  icon: string;
  items: SubMenuItem[];
}

interface SubMenuItem {
  title: string;
  selectedKey: boolean;
  pageKey: string,
  url: string;
  needCountry: boolean
}
@Component({
  selector: 'app-app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.less']
})
export class AppHeaderComponent implements OnInit, AfterViewInit  {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChild('menu') menu!: ElementRef;

  msgList: Array<number> = [1, 2, 3, 4];
  productList: any = [];
  // language: string = "en";
  theme = 'light';
  isShow: boolean = true;
  isNotificationVisible: boolean = false;
  isSalesPortal: boolean = false;
  userData: UserData | undefined;
  isLogin: boolean = false;
  userInfoVisible: boolean = false;
  form!: FormGroup;
  roleList: any[] = [];
  originMenuData: any[] = [];
  menuItems: any[] = [];
  menuItemsToDisplay: MenuItemDesktop[] = [];
  isDealerPortal: boolean = false;
  showDocuments: boolean = false;
  registerCustomerDTO: any;
  showIndex: boolean = false;//delarPortal homepage
  infoShouldApprove: boolean = false;//registerCustomerDTO is not null && hasBindCustomer is false
  userApproveInfoVisible: boolean = false;//need to submit info
  private userDataSubscription: Subscription | undefined;
  id_token: string = '';
  intervalSubscription: Subscription | undefined;
  notificationUnReadTotal: number = 0;
  headerCompanyName = '';
  showAnnouncement = false;
  noticeDto = { content: '' };
  canScrollLeft = false;
  canScrollRight = true;
  private resizeObserver: ResizeObserver | null = null;

  soldToData: any = {};

  isVisible: boolean = false;// quick add visible
  get language() {
    let config: any = localStorage.getItem('template_config');
    if (config) {
      config = JSON.parse(config);
      return config?.language || 'zh'
    }
    return 'zh'
  }

  menuItemsDesktop: MenuItemDesktop[] = [
    {
      type: 'item',
      title: 'HOME_PAGE',
      selectedKey: true,
      url: 'home/index',
      pageKey: 'homePage',
      needCountry: true,
      params: {}
    },
    {
      type: 'item',
      title: 'HOME_ECATALOG',
      selectedKey: false,
      url: 'ecatalog',
      pageKey: 'ecatalog',
      needCountry: true,
      params: {}
    },
    {
      type: 'item',
      title: 'DOWNLOAD_CENTER',
      selectedKey: false,
      url: 'documents',
      pageKey: 'documents',
      needCountry: true,
      params: {}
    },
  ];

  viceHomepage: MenuItemLink =
    {
      type: 'item',
      title: 'VICE_HOME_PAGE',
      selectedKey: false,
      url: '/home-bak/index',
      pageKey: 'viceHomepage',
      needCountry: true,
      params: { isHomeBak: 1 }
    };

  serivcesItemsDesktop: MenuItemSubmenu =
    {
      type: 'submenu',
      title: 'HEADER_WORKSHOP_SERVICE',
      selectedKey: false,
      url: '/gb/cn/services',
      pageKey: 'serivces',
      needCountry: true,
      params: {},
      highlightClass: 'highlighted',
      groups: [
        {
          title: '技术培训及支持',
          icon: 'assets/official-website/service-agent.svg',
          items: [
            {
              title: '汽车维修技术培训',
              selectedKey: false,
              pageKey: 'service-training',
              url: '/gb/cn/services/training-solutions/service-training/',
              needCountry: true,
            },
            {
              title: '培训中心',
              selectedKey: false,
              pageKey: 'equipment-services',
              url: '/gb/cn/services/service-solutions/equipment-services',
              needCountry: true,
            }
          ]
        },
        {
          title: '维修站生态体系',
          icon: 'assets/official-website/team.svg',
          items: [
            {
              title: 'BDx博世柴油系统服务网络',
              selectedKey: false,
              pageKey: 'diesel-repair',
              url: '/gb/cn/services/workshop-concepts/bosch-diesel-repair-network',
              needCountry: true,
            },
            {
              title: 'BSS博世乘用车配件优选',
              selectedKey: false,
              pageKey: 'parts-selection',
              url: '/gb/cn/services/workshop-concepts/bss-parts-selection-store',
              needCountry: true,
            },
            {
              title: 'CV Plan博世商用车增值计划',
              selectedKey: false,
              pageKey: 'cv-plan',
              url: '/gb/cn/services/workshop-concepts/cv-plan',
              needCountry: true,
            }
          ]
        },
        {
          title: '增值计划',
          icon: 'assets/official-website/truck-car-motorcycle.svg',
          items: [
            {
              title: 'eXtra易加网',
              selectedKey: false,
              pageKey: 'extra-rewards',
              url: '/gb/cn/services/programs/extra-rewards',
              needCountry: true,
            }
          ]
        }
      ]
    };

  constructor(
    private notificationService: NotificationService,
    private translate: TranslateService,
    private router: Router,
    private loginService: LoginService,
    private cartService: CartService,
    private px2RemService: Px2RemService,
    private i18n: NzI18nService,
    private customerService: CustomerService,
    private http: HttpClient,
    private sharedData: SharedDataService,
    private loadingService: LoadingService,
    private globalService: GlobalService
  ) {
    this.sharedData.currentData.subscribe(data => {
      this.isDealerPortal = data.isDealerPortal;
    });
    this.showDocuments = !window.location.pathname.includes('Salesportal');
  }

  ngOnInit(): void {
    this.setConfig();
     //user that bind customer should get menu by his role
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      if (this.isLogin) {
        this.getNotice();
      }
      if (this.isLogin && this.userData?.queryUserPageInfoResDTO?.status === 2) {
        this.getMenuList();
      }
    });
    this.userDataSubscription = this.loginService.userData$.subscribe((userData: any) => {
      this.userData = userData;
      this.id_token = userData?.tokenInfo?.id_token;
      this.isLogin = userData?.token ? true : false;
      if (this.isLogin) {
        this.menuItemsToDisplay = this.menuItems;
      } else {
        this.menuItemsToDisplay = this.menuItemsDesktop;
      }
      if (window.location.pathname.includes('Dealerportal') || window.location.pathname.includes('Salesportal')) {
        this.headerCompanyName = window.location.pathname.includes('Dealerportal') ? 'HEADER_COMPANY_NAME' : 'SALES_HEADER_COMPANY_NAME';
      }
      if (this.isLogin) {
        this.cartService.cartData$.subscribe((cartData: any) => {
          this.productList = cartData.list;
        });
        this.getSoldToList()
        if (userData?.queryUserPageInfoResDTO?.status === 2) {

          this.showIndex = true;
          //when change language, transform menu name
          this.translate.onLangChange.subscribe(() => {
            this.transformMenu();
          });

          // //user that bind customer should get menu by his role
          // this.router.events.pipe(
          //   filter((event: any) => event instanceof NavigationEnd)
          // ).subscribe(() => {
          //   this.getMenuList();
          // });

          this.getUnReadNumber();
          this.intervalSubscription = interval(30000) // 30秒
            .subscribe(() => {
              this.getUnReadNumber();
            });
        } else {

        }
      }
    });
    // check url include 'sales-portal'
    this.isSalesPortal = window.location.pathname.includes('sales-portal');

    this.customerService.selectedCustomer$.subscribe(data => {
      if (data) {
        this.soldToData = data || {}
      }
    });
    if(window.location.pathname.includes('Salesportal')) {
      this.sharedData.updateData({ isDealerPortal: false });
    }
    if(window.location.pathname.includes('Dealerportal')) {
      this.sharedData.updateData({ isDealerPortal: true });
    }
    if(window.location.href.includes("Salesportal/iam/cart/gettoken")) {
      this.sharedData.updateData({ isDealerPortal: window.location.href.includes("Dealerportal") });
    }
    // get orgList
    this.getAllOrgList();
  }

  ngAfterViewInit() {
    this.setupEventListeners();
    this.checkMenuState();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['menuItems'] && !changes['menuItems'].firstChange) {
      setTimeout(() => this.checkMenuState(), 0);
    }
  }

  getAllOrgList(): void {
    this.getOrgList({ pageNum: 1, pageSize: -1 }).subscribe(res => {
      const orgList = res.data.records;
      const result = orgList.reduce((acc: any, item: any) => {
        const key = item.router;
        const orgKey = `${item.salesOrganization}-${item.distributionChannel}-${item.division}`;
        if (!acc[key]) {
          acc[key] = [];
        }

        if (!acc[key].includes(orgKey)) {
          acc[key].push(orgKey);
        }

        return acc;
      }, {});
      localStorage.setItem('allOrgRoutes', JSON.stringify(result));
    })
  }

  scrollLeft() {
    this.scrollBy(-200);
  }

  scrollRight() {
    this.scrollBy(200);
  }
  private scrollBy(amount: number) {
    if (!this.scrollContainer) return;

    const el = this.scrollContainer.nativeElement;
    const newScrollLeft = el.scrollLeft + amount;

    el.scrollTo({
      left: newScrollLeft,
      behavior: 'smooth'
    });
  }
  private checkMenuState() {
    if (!this.scrollContainer) return;

    const el = this.scrollContainer.nativeElement;
    const wrapper = el.parentElement;

    // 使用requestAnimationFrame确保在重绘后检查
    requestAnimationFrame(() => {
      const needsArrows = el.scrollWidth > el.clientWidth + 1;

      if (needsArrows) {
        wrapper.classList.remove('hide-arrows');
        this.checkScrollButtons();
      } else {
        wrapper.classList.add('hide-arrows');
        // 重置滚动位置
        el.scrollLeft = 0;
      }
    });
  }

  private checkScrollButtons() {
    if (!this.scrollContainer) return;

    const el = this.scrollContainer.nativeElement;
    // 添加1px容差防止边界情况
    this.canScrollLeft = el.scrollLeft > 1;
    this.canScrollRight = el.scrollLeft < (el.scrollWidth - el.clientWidth - 1);
  }

  private setupEventListeners() {
    if (!this.scrollContainer) return;

    // 监听滚动事件
    this.scrollContainer.nativeElement.addEventListener('scroll', this.handleScroll);

    // 监听容器大小变化
    this.resizeObserver = new ResizeObserver(() => {
      this.checkMenuState();
    });
    this.resizeObserver.observe(this.scrollContainer.nativeElement);
  }

  private cleanupEventListeners() {
    if (!this.scrollContainer) return;

    this.scrollContainer.nativeElement.removeEventListener('scroll', this.handleScroll);

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  private handleScroll = () => {
    requestAnimationFrame(() => {
      this.checkScrollButtons();
    });
  }

  getOrgList(params: any) {
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<any>('/orgConfig/page', { params: params }, { headers });
  }


  // get notification unread total
  getUnReadNumber(): void {
    if (this.isLogin) {
      this.notificationService.getUnReadNumber().subscribe(result => {
        this.notificationUnReadTotal = result.rtnData?.totalCount;
      });
    } else {
      this.intervalSubscription?.unsubscribe();
    }
  }

  openSubPage(pageKey: string, needCountry: boolean, path: string): void {
    const country = localStorage.getItem("country");
    this.router.navigate([needCountry ? `${country}/${path}` : path]);
    this.menuItemsToDisplay.forEach(item => {
      item.selectedKey = false;
      if (item.type === 'submenu' && item.groups) {
        item.groups.forEach(group => {
          group.items.forEach(subItem => {
            subItem.selectedKey = false;
            if (pageKey === subItem.pageKey) {
              subItem.selectedKey = true;
            }
          });
        });
      }
    });
  }
  goChatbot() {
    window.open('https://kp-qa.bosch-pt.com.cn/next-frontend/embed-popup?apiKey=sme-e0919mhkh964bxnpmxqfxtvackzg&username=abc&title=AI%20%E5%B0%8F%E5%8A%A9%E6%89%8B&useTitle=%E6%88%91&botTitle=%E5%8A%A9%E6%89%8B', '_blank')
  }
  showOrHide(event: MouseEvent): void {
    event.stopPropagation();
    this.isShow = !this.isShow
  }

  goPage(path: any, needCountry: boolean, params = {}): void {
    if (path === '/gb/cn/services') {
      this.setToSubMenu();
      return;
    }
    if (path.includes('/gb/cn')) {
      this.router.navigate([path, {
        ...params
      }]);
      return;
    }
    const useStatus = this.userData?.queryUserPageInfoResDTO?.status
    if (useStatus !== 2) {
      this.loginService.sendUserPendingStatus(true)
      return
    }
    this.loginService.getPrivacyList().subscribe(res => {
      const privacyStatus: any[] = res?.data || []
      if (!(privacyStatus?.length) || privacyStatus?.some(i => i.status === 0)) {
        this.loginService.sendAgreeStatus(true)
      } else {
        if (path == '/') {
          return;
        }
        if (path == 'quick-add') {
          this.isVisible = true;
          return;
        }
        const country = localStorage.getItem("country");
        localStorage.removeItem('isOrderDetailBack');
        localStorage.removeItem('isProductDetailBack');
        this.router.navigate([needCountry ? `${country}/${path}` : path, {
          ...params
        }]);
      }
    })
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_navigation_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: '',
        event_name: '',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: path,
      });
    }
  }

  setToSubMenu() {
    const groups = this.serivcesItemsDesktop.groups;
    const allItems = groups.flatMap(group => group.items);
    this.menuItems = allItems;
  }

  goMenuPage(path: any, needCountry: boolean, menu: string, params = {}): void {
    const useStatus = this.userData?.queryUserPageInfoResDTO?.status;
    if (!this.isLogin || useStatus !== 2 || (!this.menuItemsToDisplay.length)) {
      this.goPageWidthoutLogin(path, (this.isLogin && useStatus == 2 && this.menuItemsToDisplay.length == 0) ? true : false);
      return;
    }
    if (useStatus !== 2) {
      this.loginService.sendUserPendingStatus(true)
      return
    }
    this.loginService.getPrivacyList().subscribe(res => {
      const privacyStatus: any[] = res?.data || []
      if (!(privacyStatus?.length) || privacyStatus?.some(i => i.status === 0)) {
        this.loginService.sendAgreeStatus(true)
      } else {
        if (path == '/') {
          return;
        }
        if (path == 'quick-add') {
          this.isVisible = true;
          return;
        }
        const country = localStorage.getItem("country");
        localStorage.removeItem('isOrderDetailBack');
        localStorage.removeItem('isProductDetailBack');
        this.router.navigate([needCountry ? `${country}/${path}` : path, {
          ...params
        }]);
      }
    })
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_navigation_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: '',
        event_name: '',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: path,
      });
    }

    this.menuItemsToDisplay.forEach(item => {
      item.selectedKey = false;
      if (item.type === 'submenu' && item.groups) {
        item.groups.forEach(group => {
          group.items.forEach(subItem => {
            subItem.selectedKey = false;
          });
        });
      }
    });
    const targetItem = this.menuItemsToDisplay.find(item => item.pageKey === menu);
    if (targetItem) {
      targetItem.selectedKey = true;
    }
  }

  goPageWidthoutLogin(path: string, needCountry: boolean) {
    if (path == '/') {
      return;
    }
    const country = localStorage.getItem("country");
    localStorage.removeItem('isOrderDetailBack');
    localStorage.removeItem('isProductDetailBack');
    this.router.navigate(needCountry ? [`${country}/${path}`] : [path]);
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_navigation_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: '',
        event_name: '',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: path,
      });
    }
  }

  goMenuPageWidthoutLogin(path: string, needCountry: boolean, menu: string) {
    if (path == '/') {
      return;
    }
    const country = localStorage.getItem("country");
    localStorage.removeItem('isOrderDetailBack');
    localStorage.removeItem('isProductDetailBack');
    this.router.navigate(needCountry ? [`${country}/${path}`] : [path]);
    if (environment.production) {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const customer = JSON.parse(localStorage.getItem('customer') || '{}');
      (window as any).dataLayer.push({
        event: 'dp_navigation_click',
        from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
        event_type: '',
        event_name: '',
        portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
        event_content: path,
      });
    }

    this.menuItemsToDisplay.forEach(item => {
      item.selectedKey = false;
      if (item.type === 'submenu' && item.groups) {
        item.groups.forEach(group => {
          group.items.forEach(subItem => {
            subItem.selectedKey = false;
          });
        });
      }
    });
    const targetItem = this.menuItemsToDisplay.find(item => item.pageKey === menu);
    if (targetItem) {
      targetItem.selectedKey = true;
    }
  }

  logOut(): void {
    if (this.isDealerPortal) {
      let params = {
        id_token_hint: this.id_token,
        redirectUrl: environment.logoutRequestUrl,
        token: localStorage.getItem('token') || ''
      };
      this.loginService.logout(params).subscribe(result => {
        if (result.code == 200) {
          localStorage.setItem('isLogout', 'true');
          localStorage.clear();
          this.loginService.setUserData(null);
          window.location.href = result.data;
        }
      })
    } else {
      localStorage.setItem('isLogout', 'true');
      localStorage.clear();
      this.router.navigateByUrl('home/index');
      this.loadingService.showLoading();
      setTimeout(() => {
        location.reload();
        this.loadingService.hideLoading();
      }, 4000);
    }
  }

  async getMenuList() {
    let systemId = '6';
    if (!this.isDealerPortal) {
      systemId = '8'
    }
    const result: any = await this.loginService.getMenuList({ systemId }).toPromise();
    const { code, data } = result;
    if (code === 200) {
      this.originMenuData = [...data];
      this.transformMenu();
      this.globalService.setGlobalVariable(true);
    } else {
      this.globalService.setGlobalVariable(false);
    }
  }
  transformMenu() {
    this.menuItems = [];
    let config: any = localStorage.getItem('template_config');
    if (config) {
      config = JSON.parse(config);
    }
    // Prepare portal (menu)
    let processedMenu: any[] = [];
    this.originMenuData.forEach((menu: any) => {
      const items = this.processMenu(menu, config);
      processedMenu.push(...items);
    });
    this.menuItems = processedMenu;
    console.log('menuItems:', this.menuItems)
    this.menuItemsToDisplay = this.menuItems;
    // Set menu
    localStorage.setItem("menu", JSON.stringify(processedMenu));
  }
  processMenu(menu: any, config: any): any[] {
    const menuItems: any[] = [];
    menu.childNode.forEach((subMenu: any) => {
      if (!subMenu.isHide && subMenu.menuName !== '公共API') {
        const item: any = {
          title: config?.language === 'en' ? subMenu.menuEnName : subMenu.menuName,
          url: subMenu.menuUri,
          type: 'item',
          selectedKey: false,
          pageKey: subMenu.menuUri,
          needCountry: true
        };

        // if has childNode
        if (subMenu.childNode && subMenu.childNode.length > 0) {
          item.childNode = this.processMenu(subMenu, config); // 递归调用
        }

        menuItems.push(item);
      }
    });

    if (this.isDealerPortal) {
      const index = menuItems.length > 0 ? menuItems.length - 1 : 0;
      menuItems.splice(index, 0, this.serivcesItemsDesktop);
    }
    // menuItems.push(this.viceHomepage);
    return menuItems;
  }
  // get sold to list
  getSoldToList(): void {
    let params = {
      pageNum: 1,
      pageSize: -1,
    };
    this.loginService.getSoldToList(params).subscribe(res => {
      const relations = res.data?.customerRelationVOList?.records || []
      const soldToList = relations?.map((item: any) => {
        return {
          ...item,
        }
      });
      this.soldToData = soldToList?.length ? soldToList[0] : {}

    })
  }

  userLogin(): void {
    this.sharedData.updateData({ isDealerPortal: window.location.href.includes("Dealerportal") });
    const url = window.location.href;
    if (url.includes("Salesportal")) {
      localStorage.setItem("portalName", 'Salesportal');
      this.onSSOLogin();
      console.log("URL包含Salesportal");
    } else {
      console.log("URL不包含Salesportal");
      localStorage.setItem("portalName", 'Dealerportal');
      this.goSingleKeyId();
    }


    // this.onSSOLogin();
  }

  //SSO login
  onSSOLogin() {
    window.location.href = `https://login.microsoftonline.com/0ae51e19-07c8-4e4b-bb6d-648ee58410f4/oauth2/v2.0/authorize?client_id=0bcd975c-9900-438d-8a0a-c93e7d299803&response_type=code&redirect_uri=${location.origin}/Salesportal/gettoken&scope=openid email profile`;
  }
  // go to Login Page ---> Single Key ID
  goSingleKeyId(): void {
    let client_id = environment.clientID;
    let redirect_uri = environment.redirectUrl;
    window.location.href = `${environment.singleKeyIdToprofile}/auth/connect/authorize?client_id=${client_id}&redirect_uri=${redirect_uri}&scope=openid+profile+email+phone&response_type=code&state=fdGWLdczhU&nonce=atlKOwlYwT&culture=zh-CN`;
  }
  // go to Home Page (China)---> Single Key ID
  goHome(path: any): void {
    const country = localStorage.getItem("country");
    const url = country ? `${country}/${path}` : `${path}`;
    this.router.navigateByUrl(url);
  }
  setConfig() {
    const config: any = localStorage.getItem('template_config') || '{}';
    const { language = 'en', theme = 'light' } = JSON.parse(config);
    // this.language = language;
    this.translate.use(this.language);
    this.i18n.setLocale(this.language === 'en' ? en_US : zh_CN);
  }
  convertPxToRem(px: number): string {
    return this.px2RemService.px2rem(px);
  }
  deleteAll() {
    this.cartService.removeAllFromCart(false);
  }
  // language setting，
  // changeLanguage(): void {
  //   this.language=this.language=='en'?'zh':'en';
  //   let config: any = localStorage.getItem('template_config');
  //   if (config) {
  //     config = JSON.parse(config);
  //     config = { ...config, language: this.language };
  //   } else {
  //     config = { language: this.language };
  //   }
  //   localStorage.setItem('template_config', JSON.stringify(config));
  //   this.translate.use(this.language);
  //   this.i18n.setLocale(this.language === 'en'? en_US : zh_CN);
  // }

  // language setting，
  changeLanguage(): void {
    const language = this.language === 'en' ? 'zh' : 'en';
    let config: any = localStorage.getItem('template_config');
    if (config) {
      config = JSON.parse(config);
      config = { ...config, language: language };
    } else {
      config = { language: language };
    }
    localStorage.setItem('template_config', JSON.stringify(config));
    this.translate.use(language);
    this.i18n.setLocale(language === 'en' ? en_US : zh_CN);
    location.reload();
  }
  showMessage(): void {
    this.isNotificationVisible = true;
  }
  handleClose(number: number): void {
    this.notificationUnReadTotal = number;
    this.isNotificationVisible = false;
  }

  ngOnDestroy(): void {
    this.userDataSubscription?.unsubscribe();
    this.intervalSubscription?.unsubscribe();
    this.cleanupEventListeners();
  }

  closeAnnouncement() {
    this.showAnnouncement = false;
  }

  getNotice() {
    this.loginService.getValidNotice({
      size: 20,
      current: 1,
      content: '',
      isAdmin: false,
      salesOrgVOList: []
    }).subscribe(result => {
      const { rtnCode, rtnData } = result;
      if (rtnCode === 10000 && rtnData) {
        const { total, records } = rtnData;
        if (records.length === 0) {
          this.showAnnouncement = false;
        } else {
          this.showAnnouncement = true;
        }
        this.noticeDto = records[0];
      }
    });
  }

}

